'use strict';

import React from 'react'

import Slider from 'react-slick'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

const moment = window.moment;

moment.locale('fr');

export default class MeetingRecordPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			record: { },
			loading: false
		};
	}

	componentDidUpdate ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			id: id
		};

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'ECMeetingRecord'.toLowerCase(),
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				record: response.data[0] || { },
				references: response.references,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader, theme;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		let edit_link;

		if (app.state.session.permissions.title === 'EC')
		{
			edit_link =
			(
				<div className="o-content">
					<Link className="c-btn c-btn--extra u-margin-bottom-10"
						href={ '/accueil/mon-espace/modifier-un-compte-rendu-de-reunion/' +
							state.record.id }>
						<svg className="o-svg-icon o-svg-icon--edit c-btn__icon u-margin-right-15">
							<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
						</svg>
						Modifier ce compte rendu
					</Link>
				</div>
			);
		}

		let title = 'Compte rendu du ' + moment(state.record.date).format('dddd DD MMMM');

		let content = (state.record.text || '').split('<p><br></p>').join('');

		let pdf_files = (state.record.pdfs || [])
		.filter(data => Boolean(data))
		.map(function (file, i)
		{
			let output =
			(
				<div className="u-full-width u-margin-top-10" key={ i }>
					<Link href={ file.url } type="application/pdf" target="_blank">
						{ file.filename }
					</Link>
				</div>
			);

			return output;
		});

		let pdf_files_title;

		if (pdf_files.length > 0)
		{
			pdf_files_title =
			(
				<div className="c-subtitle u-margin-top-30">
					<div className="c-subtitle__txt">
						Pièces jointes
					</div>
				</div>
			);
		}

		let output =
		(
			<Layout history={ props.history } page_title={ title } hide_title={ true }>

				<div className="page-content c-model c-model--article">

					<HolidaysMessage />

					{ edit_link }

					<div className="o-grid">

						<div className="o-grid__item-12 u-full-width">

							<div className="c-title u-no-margin-top">
								<h2 className="c-title__txt">
									{ title }
								</h2>
							</div>

							<div className="c-model__body">

								<div className={ 'c-model__description' +
									(pdf_files.length > 0 ? ' u-margin-bottom-20' : '') }
									dangerouslySetInnerHTML= { { __html: content } }>
								</div>

								{ pdf_files_title }

								{ pdf_files }

							</div>

						</div>

						{ loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
